<template>
  <body>
  <div style="width:100%;background-color: rgba(0,0,0,0)">
    <img style="height:100vh;width: 100vw;overflow: hidden; position:absolute;"
         :src="require(`@/assets/RegisterNew/bgp0${randomPic}.jpg`)"/>
    <!--登录操作框-->
    <div id="actionFrameId"  class="actionFrame">
      <div class="logo">
        <img src="~@/assets/HomeNavi/logo.png" style="position: absolute;left: calc(50% - 88px);width: 175px;height: 40px;"/>
      </div>
      <div class="titleCtn">
        <div @click="loginType=1;captchaImage()" :class="loginType==1 ? 'title-1' : 'title-2'">
          短信登录
        </div>
        <div @click="loginType=2;captchaImage()" :class="loginType==2 ? 'title-1' : 'title-2'">
          账户密码登录
        </div>
      </div>
      <div v-if="loginType==1" class="loginCtn">
        <!--手机号-->
        <div class="input-ctn" style="margin-top: 50px">
          <v-text-field
              v-model="phone1"
              label="手机号"
              placeholder=" "
              outlined
              @blur="checkPhone"
          >
            <template v-slot:prepend-inner>
              <div style="width:35px;padding-top: 3px;padding-bottom:2px;border-right: solid 1px rgba(0, 0, 0, 0.25);color:rgba(0, 0, 0, 0.35) ">
                +86
              </div>
            </template>
          </v-text-field>
        </div>
        <!--图片验证码-->
        <div class="input-ctn" style="margin-top: 15px">
          <div class="verifyInputCtn" style="margin-right: 5px">
            <v-text-field
                v-model="verifyCode"
                label="图片验证码"
                placeholder=" "
                outlined
            >
            </v-text-field>
          </div>
          <div class="verifyInputCtn" style="width: 190px;cursor:pointer;position: relative;" @click="captchaImage">
            <img :src="imgBase64" alt="" style="position: absolute;width: 190px;height: 60px;">
          </div>
        </div>
        <!--短信验证码-->
        <div class="input-ctn" style="margin-top: 15px">
          <v-text-field
              v-model="messageCode"
              label="短信验证码"
              placeholder=" "
              outlined
              @blur="ifCanRegister"
          >
            <template v-slot:append>
              <v-fade-transition leave-absolute>
                <div @click="clickSendCode" :class="canSendAgain ? 'getAccessCode':'getAccessCode-disabled'" >
                  {{countDown}}
                </div>
              </v-fade-transition>
            </template>
          </v-text-field>
        </div>
        <!--服务条款和隐私协议-->
        <div class="input-ctn" style="height: 20px;margin-top: 30px;font-size:14px">
          <v-checkbox
              v-model="read_checkbox"
              @change="ifCanRegister"
          >
            <template v-slot:label>
              <div style="font-size: 14px">
                我已阅读并同意
                <a

                    target="_blank"
                    href="/ServiceAgreement"
                    @click.stop
                    style="text-decoration:none;color:#006699"
                >
                  《服务协议》
                </a>
                和
                <a
                    target="_blank"
                    href="/PrivacyPolicy"
                    @click.stop
                    style="text-decoration:none;color:#006699"
                >
                  《隐私政策》
                </a>
                和
                <a
                    target="_blank"
                    href="/MapServiceAgreement"
                    @click.stop
                    style="text-decoration:none;color:#006699"
                >
                  《在线访问产品使用协议》
                </a>
              </div>
            </template>
          </v-checkbox>
        </div>
        <!--点击登录-->
        <div @click="clickLogin" :class="registerAllow ? 'operateButton':'operateButton_disabled'" style="margin-top: 35px;">
          登录
        </div>
      </div>
      <div v-if="loginType==2" class="loginCtn">
        <!--手机号-->
        <div class="input-ctn" style="margin-top: 50px">
          <v-text-field
              v-model="phone1"
              label="手机号"
              placeholder=" "
              outlined
              @blur="checkPhone"
          >
            <template v-slot:prepend-inner>
              <div style="width:35px;padding-top: 3px;padding-bottom:2px;border-right: solid 1px rgba(0, 0, 0, 0.25);color:rgba(0, 0, 0, 0.35) ">
                +86
              </div>
            </template>
          </v-text-field>
        </div>
        <!--密码-->
        <div class="input-ctn" style="margin-top: 15px">
          <v-text-field
              v-model="password"
              label="密码"
              placeholder=" "
              outlined
              @blur="ifCanRegister2"
              :type="ifShowPassword ? 'text' : 'password'"
          >
            <template v-slot:append>
              <v-fade-transition leave-absolute>
                <div v-if="ifShowPassword==false" @click="showPassword" style="width: 30px;height: 20px;margin-top: 5px;margin-left: 10px;cursor:pointer">
                  <img src="../assets/Login/显示密码.png" height="13" width="19"/>
                </div>
                <div v-if="ifShowPassword==true" @click="hidePassword" style="width: 30px;height: 20px;margin-top: 5px;margin-left: 10px;cursor:pointer">
                  <img src="../assets/Login/隐藏密码.png" height="16" width="19"/>
                </div>
              </v-fade-transition>
            </template>
          </v-text-field>
        </div>

        <!--忘记密码-->
        <div @click="$router.push('/ForgetPassword')" class="forgetPassword">
          忘记密码？
        </div>
        <!--图片验证码-->
        <div class="input-ctn" style="margin-top: 25px">
          <div class="verifyInputCtn" style="margin-right: 5px">
            <v-text-field
                v-model="verifyCode"
                label="图片验证码"
                placeholder=" "
                outlined
            >
            </v-text-field>
          </div>
          <div class="verifyInputCtn" style="width: 190px;cursor:pointer;position: relative;" @click="captchaImage">
            <img :src="imgBase64" alt="" style="position: absolute;width: 190px;height: 60px;">
          </div>
        </div>
        <!--服务条款和隐私协议-->
        <div class="input-ctn" style="height: 20px;margin-top: 20px">
          <v-checkbox
              v-model="read_checkbox"
              @change="ifCanRegister2"
          >
            <template v-slot:label>
              <div style="font-size: 14px">
                我已阅读并同意
                <a

                    target="_blank"
                    href="/ServiceAgreement"
                    @click.stop
                    style="text-decoration:none;color:#006699"
                >
                  《服务协议》
                </a>
                和
                <a
                    target="_blank"
                    href="/PrivacyPolicy"
                    @click.stop
                    style="text-decoration:none;color:#006699"
                >
                  《隐私政策》
                </a>
                和
                <a
                    target="_blank"
                    href="/MapServiceAgreement"
                    @click.stop
                    style="text-decoration:none;color:#006699"
                >
                  《在线访问产品使用协议》
                </a>
              </div>
            </template>
          </v-checkbox>
        </div>
        <!--点击登录-->
        <div @click="clickLogin3" :class="registerAllow2 ? 'operateButton':'operateButton_disabled'" style="margin-top: 35px;">
          登录
        </div>
      </div>
      <!--底部文字-->
      <div class="text-ctn" style="margin-top: 5px">
        尚未创建吉林一号账号？现在就去<span @click="$router.push('/Register')" style="color: #006699;cursor:pointer;">注册</span>
      </div>
      <div class="text2-ctn" style="font-size: 12px">
        Copyright © 2023-2026 长光卫星技术股份有限公司
        <a
            target="_blank"
            href="/PrivacyPolicy"
            @click.stop
            style="text-decoration:none;color: #979797;"
        >
          · 隐私政策
        </a>
        <a
            target="_blank"
            href="/ServiceAgreement"
            @click.stop
            style="text-decoration:none;color: #979797;"
        >
          · 服务协议</a>
        <a
            target="_blank"
            href="/MapServiceAgreement"
            @click.stop
            style="text-decoration:none;color: #979797;"
        >
          · 在线访问产品使用协议</a>

      </div>
      <!--错误提示-->
      <div v-if="showAlert" class="alertCtn">
        {{alertTip}}
        <img class="closeAlert" @click="showAlert=false;" src="../assets/RegisterNew/关闭提示内容.png" height="22" width="22"/>
      </div>
    </div>
  </div>
  </body>

</template>

<script>
import JSEncrypt from 'jsencrypt'
export default {
  name: "Login",
  components:{
  },
  data(){
    return{
      ifShowPassword:false,
      registerAllow2:false,//判断是否可以登录（账户密码登录）
      phone2:'',//电话，账户密码登录
      password:'',
      // 图片验证码的随机取值范围
      identifyCodes: '1234567890',
      showAlert:false,//是否现实错误提示
      alertTip:'',//错误提示内容
      countDown:'获取验证码',//发送验证码，与再次发送倒计时
      read_checkbox:false,
      checkPhoneResult:false,//手机号是否正确
      canSendAgain:true,
      registerAllow:false,//是否可以登录
      messageCode:'',//短信验证码
      verifyCode:'',//图片验证码
      phone1:'',//手机号码（短信登录）
      loginType:1,
      randomPic:7,//1-7随机数，用于选择背景图片
      returnUrl:'',//需要返回的上一个页面
      fromUrl:'',//需要返回的上一个页面，用于多系统联系，优先级高于returnUrl
      imgBase64:'',
      uuid:'',
      encrypted:''
    }
  },
  methods:{
    //识别屏幕缩放比例
    detectZoom(){
      var ratio = 0,
          screen = window.screen,
          ua = navigator.userAgent.toLowerCase();

      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
      }
      else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
      }
      else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        ratio = window.outerWidth / window.innerWidth;
      }
      if (ratio){
        ratio = Math.round(ratio * 100);
      }
      return ratio;
    },
    //设置显示密码
    showPassword(){
      this.ifShowPassword=true;
    },
    //设置隐藏密码
    hidePassword(){
      this.ifShowPassword=false;
    },
    //获取图片验证码
    captchaImage(){
      this.axios.get("/loginapi/captchaImage?type=login").then((res) => {
        if(res.data.code==200){
          this.imgBase64=res.data.data.img
          this.uuid=res.data.data.uuid
        }else{
          this.alertTip='获取图片验证码失败'
          this.showAlert=true
        }
      })
    },
    //验证手机格式
    phonePattern:function(phone){
      const pattern = /^[0-9]{11}$/
      if(phone) {
        return pattern.test(phone) || '请填写正确的手机号码'
      }
      else {
        return '请填写正确的手机号码'
      }
    },
    //检验手机号码格式
    checkPhone:function(){
      let checkResult=this.phonePattern(this.phone1)
      this.checkPhoneResult=checkResult
      //如果手机号通过正则检验
      if(checkResult==true){
        //取消电话号码格式错误或验证码错误提示
        this.alertTip='';
        this.showAlert=false;
      }
      else {
        this.alertTip=checkResult;
        this.showAlert=true;
      }
    },
    //点击获取验证码
    clickSendCode:function () {
      let checkResult=this.phonePattern(this.phone1)
      this.checkPhoneResult=checkResult
      //如果手机号通过正则检验
      if(checkResult==true){
        //取消电话号码格式错误或验证码错误提示
        this.alertTip='';
        this.showAlert=false;
        //如果可以发送验证码
        if(this.canSendAgain){
          //立即禁用按钮，防止重复点击
          this.canSendAgain=false;
          //调用发送验证码的函数
          this.sendCode()
        }
      }
      else {
        this.alertTip=checkResult;
        this.showAlert=true;
      }

    },
    //json加密
    RSA_encryption(jsonData){
      var PUBLIC_KEY='MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2i8ZSgjf9ARRHRC/fFlGlWV6j6z78//8YlxGlAOq4a4tNS/Da35mfwkPM1qa7lr9dwjmT5CwTJVuHoUfsA5CmMHi+x+9vF5eyy62m1/yv8zgIwdQEaD0SLjDrnzqhM9k/vxpWR/d64rz6zUEwbYJM7NgNohlg3vqBYZlTJL7t5/145+CnSzmhIaeBl4sbAulFydGTqDWvzvfR6Y9eBQUQjyEyLom1vS4piq2OYAKVkX1ozo05xt49mD9eUYdDfHlxOsbPl8DwXpxl2XiJR3+vXkNIFKTdPTSYKR3Gh17sQelX+GwF0nixCAaqplUnw+/FVBmtBkih/eplGTQ8f5mDwIDAQAB'
      var encrypt = new JSEncrypt()
      encrypt.setPublicKey('-----BEGIN PUBLIC KEY-----' + PUBLIC_KEY + '-----END PUBLIC KEY-----')
      var encrypted = encrypt.encrypt(JSON.stringify(jsonData))
      this.encrypted=encrypted
    },
    //发送验证码函数
    sendCode:function(){
      var json={
        "phone": this.phone1,
        "uuid": this.uuid,
        "code": this.verifyCode
      }
      this.RSA_encryption(json)
      this.axios.post("/loginapi/loginCodeVerify",this.encrypted,{
        headers: {
          'Content-Type': "application/json;charset=utf-8",
        },
      }).then((res)=>{
        let resData=res.data;
        if(resData.success==false){
          //失败时恢复按钮状态，允许用户重试
          this.canSendAgain=true;
          if(resData.code==50001){
              this.alertTip='手机号或密码为空，请重新填写'
              this.showAlert=true
            }else if(resData.code==50002){
                this.alertTip='该手机号未注册，请先注册'
                this.showAlert=true
            }else if(resData.code==50003){
                this.alertTip='用户名或密码错误'
                this.showAlert=true
            }else if(resData.code==50004){
                this.alertTip='该账号已被冻结，详情请联系商务经理'
                this.showAlert=true
            }else if(resData.code==50005){
                this.alertTip='登陆异常，请重新登录'
                this.showAlert=true
            }else if(resData.code==50006){
                this.alertTip='账户达到规定错误次数，请5分钟后重新登录!'
                this.showAlert=true
            }else if(resData.code==50007){
                    this.$store.state.user.phone=this.phone1
                    this.$store.state.user.password=this.password
                    this.$router.push("/EditPassword");
            }else if(resData.code==50008){
                this.alertTip='验证码错误或已失效!'
                this.showAlert=true
                this.captchaImage()
            }
        }else{
          this.sendAgainCountDown();
        }
      })
    },
    //发送倒计时
    sendAgainCountDown:function(){
      let t=60;
      this.canSendAgain=false;
      let timer=setInterval(()=> {
        this.countDown='重新发送 ('+t+'s)'
        t--;
        if(t<0){
          this.canSendAgain=true;
          this.countDown='获取验证码'
          clearInterval(timer);
        }
      },1000)
    },
    //设置token
    setKey(value) {
      localStorage.setItem("token", value);
    },
    //点击登录
    clickLogin:function(){
      if(this.registerAllow){
        let param=new FormData();
        param.append('phone', this.phone1)
        param.append('verifyCode',this.messageCode)
        this.axios.post("/loginapi/checkCodeForLogin",param)
            .then((res)=>{
              let resData=res.data;
              if(resData.success==false){
                if(resData.code==50001){
                  this.alertTip='手机号或密码为空，请重新填写'
                  this.showAlert=true
                }else if(resData.code==50002){
                  this.alertTip='该手机号未注册，请先注册'
                  this.showAlert=true
                }else if(resData.code==50003){
                  this.alertTip='用户名或密码错误'
                  this.showAlert=true
                }else if(resData.code==50004){
                  this.alertTip='该账号已被冻结，详情请联系商务经理'
                  this.showAlert=true
                }else if(resData.code==50005){
                  this.alertTip='登陆异常，请重新登录'
                  this.showAlert=true
                }else if(resData.code==50006){
                  this.alertTip='账户达到规定错误次数，请5分钟后重新登录!'
                  this.showAlert=true
                }else if(resData.code==50007){
                  this.$store.state.user.phone=this.phone1
                  this.$store.state.user.password=this.password
                  this.$router.push("/EditPassword");
                }else if(resData.code==50008){
                  this.alertTip='验证码错误或已失效!'
                  this.showAlert=true
                }
              }else{
                this.$store.state.user.userId = resData.data.account;
                this.setCookie('userId', resData.data.account);
                this.$store.state.accountId = resData.data.userId;
                this.$store.state.user.logined = true;
                this.setKey(resData.data.key);
                //优先使用fromUrl返回，fromUrl为绝对地址，没有则使用returnUrl返回
                if(this.fromUrl){
                  window.open(this.fromUrl,"_self");
                  return;
                }
                else {
                  if (this.returnUrl !== "") {
                    this.$router.push(this.returnUrl);
                  } else {
                    this.$router.push("/");
                  }
                }
                this.alertTip="";
                this.showAlert=false;
              }
            })
      }

    },
    //点击登录（账号密码）
    clickLogin2:function(){
      if(this.registerAllow2){
        let param=new FormData();
        param.append('username', this.phone1)
        param.append('password',this.password)
        param.append('remember','on')
        this.axios.post("/loginapi/login",param)
            .then((res)=>{
              this.print(res)
              let resData=res.data;
              if(resData.success==false){
                this.alertTip=resData.message;
                this.showAlert=true;
              }
              else if(resData.success==true){
                this.$store.state.user.userId = resData.data.account;
                this.setCookie('userId', resData.data.account);
                this.$store.state.accountId = resData.data.userId;
                this.$store.state.user.logined = true;
                this.setKey(resData.data.key);//设置token
                //优先使用fromUrl返回，fromUrl为绝对地址，没有则使用returnUrl返回
                if(this.fromUrl){
                  window.open(this.fromUrl,"_self");
                  return;
                }
                else {
                  if (this.returnUrl !== "") {
                    this.$router.push(this.returnUrl);
                  } else {
                    this.$router.push("/");
                  }
                }
                this.alertTip="";
                this.showAlert=false;
              }
            })
      }
    },
    //点击登录(修改密码)
    clickLogin3:function(){
      if(this.registerAllow2){
        var json={
          "phone": this.phone1,
          "password":this.password,
          "uuid": this.uuid,
          "code": this.verifyCode
        }
        this.RSA_encryption(json)
        this.axios.post("/loginapi/loginVerify",this.encrypted,{
          headers: {
            'Content-Type': "application/json;charset=utf-8",
          },
        }).then((res)=>{
          let resData=res.data;
          if(resData.success==false){
            if(resData.code==50001){
              this.alertTip='手机号或密码为空，请重新填写'
              this.showAlert=true
            }else if(resData.code==50002){
              this.alertTip='该手机号未注册，请先注册'
              this.showAlert=true
            }else if(resData.code==50003){
              this.alertTip='用户名或密码错误'
              this.showAlert=true
            }else if(resData.code==50004){
              this.alertTip='该账号已被冻结，详情请联系商务经理'
              this.showAlert=true
            }else if(resData.code==50005){
              this.alertTip='登陆异常，请重新登录'
              this.showAlert=true
            }else if(resData.code==50006){
              this.alertTip='账户达到规定错误次数，请5分钟后重新登录!'
              this.showAlert=true
            }else if(resData.code==50007){
              this.$store.state.user.phone=this.phone1
              this.$store.state.user.password=this.password
              this.$router.push("/EditPassword");
            }else if(resData.code==50008){
              this.alertTip='验证码错误或已失效!'
              this.showAlert=true
            }
          }else{
            this.$store.state.user.phone=resData.data.phone
            this.$store.state.user.password=''
            this.$store.state.user.userId = resData.data.account;
            this.setCookie('userId', resData.data.account);
            this.$store.state.accountId = resData.data.userId;
            this.$store.state.user.logined = true;
            this.setKey(resData.data.key);//设置token
            // 优先使用fromUrl返回，fromUrl为绝对地址，没有则使用returnUrl返回
            if(this.fromUrl){
              window.open(this.fromUrl,"_self");
              return;
            }
            else {
              if (this.returnUrl !== "") {
                this.$router.push(this.returnUrl);
              } else {
                this.$router.push("/");
              }
            }
            this.alertTip="";
            this.showAlert=false;
          }
        })



      }
    },
    //判断是否可以登录
    ifCanRegister:function(){
      if(this.checkPhoneResult==true&&this.read_checkbox==true&&this.messageCode.length>1){
        this.registerAllow=true
      }
      else {
        this.registerAllow=false
      }

    },
    //判断是否可以登录(账户密码方式)
    ifCanRegister2:function(){
      if(this.checkPhoneResult==true&&this.read_checkbox==true&&this.password.length>1){
        this.registerAllow2=true
      }
      else {
        this.registerAllow2=false
      }
    },
  },
  mounted(){
    //获取验证码
    this.captchaImage()
    //获取fromUrl
    let fromUrl=""
    //防止都小写
    if(this.$route.query.fromUrl){
      fromUrl=this.$route.query.fromUrl;
    }else if(this.$route.query.fromurl){
      fromUrl=this.$route.query.fromurl;
    }
    this.fromUrl=fromUrl;
    //获取returnUrl
    if (
        this.$route.query.returnUrl != "" &&
        this.$route.query.returnUrl != undefined
    ) {
      this.returnUrl = this.$route.query.returnUrl;
    }
    console.log("返回地址fromUrl")
    console.log(this.fromUrl)
    console.log("返回地址returnUrl")
    console.log(this.returnUrl)
    //屏幕适应问题
    let screenZoom=this.detectZoom() //屏幕放大倍数
    let screenWidth=window.screen.width
    let divFrame = document.getElementById("actionFrameId");
    if(screenWidth<2500){
      divFrame.setAttribute("style","zoom:"+(100-(screenZoom-100)/1.8).toFixed(2).toString()+"%");
    }
  },
  created(){
    this.randomPic=Math.floor((Math.random() * 7) + 1);
  }
  ,
  watch:{
    messageCode: {
      handler: function() {
        if(this.messageCode.length>5){
          this.ifCanRegister();
        }
      }
    },
    password:{
      handler:function () {
        if(this.password.length>5){
          this.ifCanRegister2();
        }
      }
    }
  }
}
</script>

<style scoped>
.v-label {
  font-size: 14px;
  line-height: 1;
  min-height: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.forgetPassword{
  position:absolute;
  top:372px;
  left:550px;
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 20px;
  cursor:pointer;
}
.loginCtn{
  width: 100%;
  height:430px;
  padding-top: 1px;
}
.text2-ctn{
  position:absolute;
  bottom:30px;
  left: 60px;
  width: 560px;
  min-height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #979797;
  line-height: 17px;
}
.text-ctn{
  margin-left: 62px;
  width: 560px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  line-height: 20px;
}
.verifyInputCtn{
  width:360px;
  height:60px;
  float:left;
}
.input-ctn{
  width: 560px;
  height: 60px;
  margin-left: 60px;
}
.title-1{
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
  line-height: 28px;
  border-bottom: 3px solid #006699;
  float:left;
  margin-right: 40px;
  padding-bottom: 10px;
  cursor:pointer;
}
.title-2{
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #979797;
  line-height: 28px;
  float:left;
  margin-right: 40px;
  padding-bottom: 10px;
  cursor:pointer;
}
.operateButton {
  margin-left: 60px;
  width: 560px;
  height: 54px;
  line-height: 54px;
  background: #006699;
  border-radius: 8px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}
.operateButton_disabled{
  margin-left: 60px;
  width: 560px;
  height: 54px;
  line-height: 54px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
  cursor:pointer;
}
.getAccessCode {
  width: 150px;
  margin-top: 5px;
  /*height: 40px;*/
  /*line-height: 40px;*/
  text-align: right;
  padding-right: 10px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #006699;
  cursor: pointer;
}
.getAccessCode-disabled{
  width: 150px;
  margin-top: 5px;
  /*height: 40px;*/
  /*line-height: 40px;*/
  text-align: right;
  padding-right: 10px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #979797;
  cursor: pointer;
}
.titleCtn{
  width: 100%;
  height: 35px;
  margin-top: 110px;
  padding-left: 61px;
}
.logo{
  position:relative;
  top:58px;
  left:204px;
  width: 272px;
  height: 44px;
  text-align: center;
  padding-right: 15px;
}
.closeAlert{
  position:absolute;
  top:16px;
  right:16px;
  cursor:pointer;
}
.alertCtn{
  position:absolute;
  top:-94px;
  left:0px;
  width: 680px;
  height: 54px;
  line-height: 54px;
  background: #FF4040;
  border-radius: 8px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
}
.actionFrame{
  position:absolute;
  left:50%;
  top:50%;
  margin-top: -330px;
  margin-left: -340px;
  width: 680px;
  height: 720px;
  background: #FFFFFF;
  border-radius: 16px;
}
</style>
